const alphabet = {
  65: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Close-mid_front_unrounded_vowel.ogg',
  },
  75: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Close_back_rounded_vowel.ogg',
  },
  97: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Open_front_unrounded_vowel.ogg',
  },
  98: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_bilabial_plosive.ogg',
  },
  99: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_palatal_plosive.ogg',
  },
  100: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_alveolar_plosive.ogg',
  },
  101: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Close-mid_front_unrounded_vowel.ogg',
  },
  102: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_labiodental_fricative.ogg',
  },
  104: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_glottal_fricative.ogg',
  },
  105: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Close_front_unrounded_vowel.ogg',
  },
  106: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Palatal_approximant.ogg',
  },
  107: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_velar_implosive.ogg',
  },
  108: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Alveolar_lateral_approximant.ogg',
  },
  109: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Bilabial_nasal.ogg',
  },
  110: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Alveolar_nasal.ogg',
  },
  111: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Close-mid_back_rounded_vowel.ogg',
  },
  112: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_bilabial_plosive.ogg',
  },
  114: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Alveolar_trill.ogg',
  },
  115: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_alveolar_fricative.ogg',
  },
  116: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_alveolar_plosive.ogg',
  },
  117: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Close_back_rounded_vowel.ogg',
  },
  118: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_labiodental_fricative.ogg',
  },
  119: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_labio-velar_approximant.ogg',
  },
  120: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_velar_fricative.ogg',
  },
  121: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Close_front_rounded_vowel.ogg',
  },
  122: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_alveolar_fricative.ogg',
  },
  593: {
    name: 'open back unrounded',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Open_back_unrounded_vowel.ogg',
  },
  0x025102d0: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Open_back_unrounded_vowel.ogg',
  },
  592: { name: 'open-mid schwa' },
  594: {
    name: 'open back rounded',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Open_back_rounded_vowel.ogg',
  },
  230: {
    name: 'raised open front unrounded',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Near-open_front_unrounded_vowel.ogg',
  },
  595: {
    name: 'vd bilabial implosive',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_bilabial_implosive.ogg',
  },
  665: { name: 'vd bilabial trill' },
  946: { name: 'vd bilabial fricative' },
  596: {
    name: 'open-mid back rounded',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Open-mid_back_rounded_vowel.ogg',
  },
  597: { name: 'vl alveolopalatal fricative' },
  231: { name: 'vl palatal fricative' },
  599: {
    name: 'vd alveolar implosive',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_alveolar_implosive.ogg',
  },
  598: { name: 'vd retroflex plosive' },
  240: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_dental_fricative.ogg',
  },
  676: { name: 'vd postalveolar affricate' },
  601: {
    name: 'schwa',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Mid-central_vowel.ogg',
  },
  600: { name: 'close-mid schwa' },
  602: { name: 'rhotacized schwa' },
  603: {
    name: 'open-mid front unrounded',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Open-mid_front_unrounded_vowel.ogg',
  },
  604: { name: 'open-mid central' },
  605: { name: 'rhotacized open-mid central' },
  606: { name: 'open-mid central rounded' },
  607: { name: 'vd palatal plosive' },
  644: { name: 'vd palatal implosive' },
  609: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_velar_plosive.ogg',
  },
  608: { name: 'vd velar implosive' },
  610: { name: 'vd uvular plosive' },
  667: { name: 'vd uvular implosive' },
  614: { name: 'vd glottal fricative' },
  615: { name: 'vl multiple-place fricative' },
  295: { name: 'vl pharyngeal fricative' },
  613: {
    name: 'labial-palatal approximant',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Labial-palatal_approximant.ogg',
  },
  668: { name: 'vl epiglottal fricative' },
  616: {
    name: 'close central unrounded',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Close_central_unrounded_vowel.ogg',
  },
  618: {
    name: 'lax close front unrounded',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Near-close_near-front_unrounded_vowel.ogg',
  },
  669: { name: 'vd palatal fricative' },
  621: { name: 'vd retroflex lateral' },
  620: { name: 'vl alveolar lateral fricative' },
  619: {
    name: 'velarized vd alveolar lateral (ready-made combination, dark l)',
  },
  622: { name: 'vd alveolar lateral fricative' },
  671: { name: 'vd velar lateral' },
  625: { name: 'vd labiodental nasal' },
  623: { name: 'close back unrounded' },
  624: { name: 'velar approximant' },
  331: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Velar_nasal.ogg',
  },
  627: { name: 'vd retroflex nasal' },
  626: {
    name: 'vd palatal nasal',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Palatal_nasal.ogg',
  },
  628: { name: 'vd uvular nasal' },
  248: {
    name: 'front close-mid rounded',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Close-mid_front_rounded_vowel.ogg',
  },
  629: { name: 'rounded schwa' },
  632: { name: 'vl bilabial fricative' },
  952: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_dental_fricative.ogg',
  },
  339: {
    name: 'front open-mid rounded',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Open-mid_front_rounded_vowel.ogg',
  },
  630: { name: 'front open rounded' },
  664: { name: 'bilabial click' },
  633: { name: 'vd (post)alveolar approximant' },
  634: { name: 'vd alveolar lateral flap' },
  638: { name: 'vd alveolar tap' },
  635: { name: 'vd retroflex approximant' },
  640: { name: 'vd uvular trill' },
  641: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_uvular_fricative.ogg',
  },
  637: { name: 'vd retroflex flap' },
  642: {
    name: 'vl retroflex fricative',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_retroflex_fricative.ogg',
  },
  643: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_postalveolar_fricative.ogg',
  },
  648: {
    name: 'vl retroflex plosive',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_retroflex_plosive.ogg',
  },
  679: { name: 'vl postalveolar affricate' },
  649: { name: 'close central rounded' },
  650: {
    name: 'lax close back rounded',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Near-close_near-back_rounded_vowel.ogg',
  },
  651: { name: 'vd labiodental approximant' },
  11377: { name: 'voiced labiodental flap' },
  652: {
    name: 'open-mid back unrounded',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Open-mid_back_unrounded_vowel.ogg',
  },
  611: {
    name: 'vd velar fricative',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_velar_fricative.ogg',
  },
  612: { name: 'close-mid back unrounded' },
  653: { name: 'vl labial-velar fricative' },
  967: { name: 'vl uvular fricative' },
  654: { name: 'vd palatal lateral' },
  655: { name: 'lax close front rounded' },
  657: { name: 'vd alveolopalatal fricative' },
  656: { name: 'vd retroflex fricative' },
  658: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_postalveolar_fricative.ogg',
  },
  660: {
    name: 'glottal plosive',
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Glottal_stop.ogg',
  },
  673: { name: 'vd epiglottal plosive' },
  661: { name: 'vd pharyngeal fricative' },
  674: { name: 'vd epiglottal fricative' },
  448: { name: 'dental click' },
  449: { name: 'alveolar lateral click' },
  450: { name: 'alveolar click' },
  451: { name: 'retroflex click' },
  712: { name: '(primary) stress mark' },
  716: { name: 'secondary stress' },
  720: {
    name: 'length mark NB: there is a bug in some versions of MS IExplorer that causes this character not to display. It is probably best to use a simple colon instead.',
  },
  721: { name: 'half-length' },
  700: { name: 'ejective' },
  692: { name: 'rhotacized' },
  688: { name: 'aspirated' },
  689: { name: 'breathy-voice-aspirated' },
  690: { name: 'palatalized' },
  695: { name: 'labialized' },
  736: { name: 'velarized' },
  740: { name: 'pharyngealized' },
  734: { name: 'rhotacized' },
  805: { name: 'voiceless' },
  778: { name: 'voiceless (use if character has descender)' },
  804: { name: 'breathy voiced' },
  810: { name: 'dental' },
  812: { name: 'voiced' },
  816: { name: 'creaky voiced' },
  826: { name: 'apical' },
  828: { name: 'linguolabial' },
  827: { name: 'laminal' },
  794: { name: 'not audibly released' },
  825: { name: 'more rounded' },
  771: { name: 'nasalized' },
  796: { name: 'less rounded' },
  799: { name: 'advanced' },
  800: { name: 'retracted' },
  776: { name: 'centralized' },
  820: { name: 'velarized or pharyngealized' },
  829: { name: 'mid-centralized' },
  797: { name: 'raised' },
  809: { name: 'syllabic' },
  798: { name: 'lowered' },
  815: { name: 'non-syllabic' },
  792: { name: 'advanced tongue root' },
  793: { name: 'retracted tongue root' },
  774: { name: 'extra-short' },
  779: { name: 'extra high tone' },
  769: { name: 'high tone' },
  772: { name: 'mid tone' },
  768: { name: 'low tone' },
  783: { name: 'extra low tone' },
  860: { name: 'tie bar below' },
  865: { name: 'tie bar above' },
  0x7403610255: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_alveolo-palatal_affricate.ogg',
  },
  0x61026a: {},
  0x61028a: {},
  0x65026a: {},
  0x6902d0: {},
  0x6f028a: {},
  0x7502d0: {},
  0x025402d0: {},
  0x0254026a: {},
  0x640292: {},
  0x025b02d0: {},
  0x02520303: {},
  0x025b0303: {},
  0x01530303: {},
  0x02540303: {},
  0x690065: {},
  0x750065: {},
  0x6b02b7: {},
  0x6b02b0: {},
  0x7402b0: {},
  0x6102d0: {},
  0x025902d0: {},
  0x690259: {},
  0x02680259: {},
  0x750259: {},
  0x028803610282: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_retroflex_affricate.ogg',
  },
  0x006403610292: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiced_postalveolar_affricate.ogg',
  },
  0x007403610283: {
    sound:
      'https://www.internationalphoneticalphabet.org/ipa-chart-audio/ogg/Voiceless_palato-alveolar_affricate.ogg',
  },
};
export default alphabet;
